import React, { useEffect } from 'react'
import Lottie from 'react-lottie'
import animationData from '../assets/lottie/loading.json'

export const UserLoader = () => {
  return (
    <div className="page-loader">
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData,
        }}
        height={100}
        width={100}
        isStopped={false}
        isPaused={false}
      />
    </div>
  )
}

export const LayoutLoader = ({ text = '' }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(255,255,255, 0.8)',
        zIndex: 999999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        flexDirection: 'column',
      }}
    >
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData,
        }}
        height={100}
        width={100}
        isStopped={false}
        isPaused={false}
      />
      <div>{text}</div>
    </div>
  )
}

export default LayoutLoader
